import type { MarketplaceListing } from "./types";

export const MAX_DRAFT_PHOTOS = 6;
export interface ListingAuthoringValues { title: string; description: string; priceMinor: number; }
export interface ListingAuthoringQuestion { id: string; prompt: string; answer: string; }
export interface ListingAuthoringDraft {
  version: string;
  baseUpdatedAt: string;
  evidenceFingerprint: string;
  values: ListingAuthoringValues;
  details: string;
  questions: ListingAuthoringQuestion[];
  state: "editing" | "generating" | "suggested" | "failed";
  photoIDs: string[];
  generatedAt?: string;
  generationID?: string;
  startedAt?: string;
  error?: string;
  updatedAt: string;
}
export interface ListingAuthoringRequest {
  action: "open" | "save" | "generate" | "accept" | "discard" | "rebase";
  expectedVersion?: string;
  values?: ListingAuthoringValues;
  details?: string;
  answers?: Record<string, string>;
}
export interface ListingAuthoringResult {
  draft: ListingAuthoringDraft;
  listing: MarketplaceListing;
  available: boolean;
  sourceChanged: boolean;
}
export function listingAuthoringValues(listing: MarketplaceListing): ListingAuthoringValues {
  return { title: listing.title, description: listing.description, priceMinor: listing.price.amountMinor };
}
export function sameListingAuthoringValues(a: ListingAuthoringValues, b: ListingAuthoringValues) {
  return a.title === b.title && a.description === b.description && a.priceMinor === b.priceMinor;
}
